import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";

const footerLinks = [
  { label: "About", to: "/about" },
  { label: "Academics", to: "/academics" },
  { label: "Electives & Faith", to: "/electives" },
  { label: "School Format", to: "/school-format" },
  { label: "School Life", to: "/school-life" },
  { label: "Learning & Placement", to: "/learning-placement" },
  { label: "Tuition & Admissions", to: "/admissions" },
  { label: "Inquire", to: "/inquire" },
];

const Footer = ({ showQuote = false }) => {
  return (
    <footer className="bg-[#fbf7ee] border-t border-[#eae1c4]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-12">
        {showQuote && (
          <div className="flex flex-col items-center text-center gap-3 mb-10">
            <div className="flex items-center justify-center gap-4">
              <span className="block h-px w-40 bg-[#c9a961]"></span>
              <span className="text-[#c9a961]">†</span>
              <span className="block h-px w-40 bg-[#c9a961]"></span>
            </div>
            <p className="font-serif-body italic text-[#3a466e] text-[16px] md:text-[17px] max-w-3xl">
              “The soul is perfected by knowledge and virtue.”
              <span className="not-italic font-sans-nav text-[11px] tracking-[0.22em] uppercase text-[#8a7a4e] block mt-2">
                — St. Thomas Aquinas, Summa Contra Gentiles
              </span>
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 items-start">
          <BrandLogo
            testId="footer-logo-link"
            className="justify-self-start w-[180px] md:w-[200px] lg:w-[220px]"
          />

          <div>
            <div className="font-sans-nav text-[11px] tracking-[0.28em] uppercase text-[#8a7a4e] mb-4">Explore</div>
            <ul className="grid grid-cols-2 grid-flow-col grid-rows-4 gap-y-2 gap-x-6">
              {footerLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-serif-body text-[15px] text-[#1e2952] hover:text-[#c9a961] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <a
              href="mailto:admissions@angelofpeaceacademy.org"
              data-testid="footer-contact-email"
              className="block font-sans-nav text-[11px] tracking-[0.24em] uppercase text-[#1e2952] hover:text-[#c9a961] transition-colors mb-4"
            >
              admissions@angelofpeaceacademy.org
            </a>
            <div className="font-display text-[#1e2952] text-[22px] leading-[1.2]" style={{ fontWeight: 500 }}>
              The Faith Lived.
              <br />
              The Faith Loved.
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#eae1c4] flex items-center justify-center">
          <p className="font-sans-nav text-[11px] tracking-[0.24em] uppercase text-[#8a7a4e]">
            © {new Date().getFullYear()} Angel of Peace Academy
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
